import mixpanel from 'mixpanel-browser'
import { combineAnalytics } from 'aria-viewer/core/middleware/analyticsMiddleware'
import { MIXPANEL_TOKEN } from 'aria-viewer/tour/constants'

import paymentAnalytics from 'aria-viewer/payments/analytics/mobileAnalytics'
import modalAnalytics from 'aria-viewer/modal/analytics/mobileAnalytics'
import ctaPromptAnalytics from 'aria-viewer/ctaPrompt/analytics/mobileAnalytics'
import tourAnalytics from 'aria-viewer/tour/analytics/mobileAnalytics'
import analyticAnalytics from 'aria-viewer/analytics/analytics/mobileAnalytics'
import drawerAnalytics from 'aria-viewer/drawer/analytics'
import guideAnalytics from 'aria-viewer/guide/analytics'
import { interactiveElementsAnalytics } from 'aria-viewer/interactive-element'
import panoPlayerAnalytics from 'aria-viewer/players/panoplayer/analytics'

const customMapper = {
    analytics: mixpanel,

    token: MIXPANEL_TOKEN,

    mapper: combineAnalytics(
        paymentAnalytics,
        modalAnalytics,
        ctaPromptAnalytics,
        tourAnalytics,
        analyticAnalytics,
        drawerAnalytics,
        guideAnalytics,
        interactiveElementsAnalytics,
        panoPlayerAnalytics
    ),
}

export default customMapper
